// extracted by mini-css-extract-plugin
export default {"root":"LNWaT0S2jU"};